import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Label, Mensagem } from '../../../environments/resource';
import { Usuario } from '../../models/usuario';
import { environment } from 'environments/environment';

// Autenticação - services
import { AutenticacaoService, SistemaGestaoService } from '../../services';

@Component({
    selector: 'app-header',
    templateUrl: './app-header.component.html',
    providers: [
        SistemaGestaoService
    ]
})
export class AppHeader implements OnInit {
    label = Label;
    mensagem = Mensagem;
    usuario: Usuario;
    linkAuditoria = false;
    i = 0;
    homologacao = !environment.production;

    paginaPerfil = '/perfil/dados-pessoais';
    listaSistemaGestao = [];

    linkdeNorma: any = [];
    linksAuditor: any = [];
    linksAdmin: any = [];
    linksFornecedor: any = [{ link: '/certificado', label: this.label.certificados }];
    linksIEL: any = [];
    linksGT: any =
        [{ link: '/auditor', label: this.label.auditores },
        /* { link: '/auditoria', label: this.label.auditoriasAndamento }, */
        { link: '/certificado', label: this.label.certificados }];
    // Secretaria e CE
    linksPadrao: any =
        [{ link: '/fornecedor', label: this.label.fornecedores },
        { link: '/auditor', label: this.label.auditores },
        /* { link: '/auditoria', label: this.label.auditoriasAndamento }, */
        { link: '/certificado', label: this.label.certificados }/*,
        { link: 'sistema-gestao', label:this.label.norma}*/];

    linksExibir: any = [];

    constructor(
        private authService: AutenticacaoService,
        private sgService: SistemaGestaoService,
        private router: Router) { }

    ngOnInit(): void {
        this.usuario = this.authService.user;
        // altera a página de alteração de perfil
        if (this.usuario.perfis.toUpperCase().indexOf('FORNECEDOR') >= 0) {
            this.paginaPerfil = '/perfil/dados-fornecedor';
            this.linksExibir = this.linksFornecedor;
        } else if (this.usuario.perfis.toUpperCase().indexOf('AUDITOR') >= 0) {
            this.paginaPerfil = '/perfil/dados-auditor';
            this.linksExibir = this.linksAuditor;
        } else if (this.usuario.perfis.toUpperCase().indexOf('GT') >= 0) {
            this.linksExibir = this.linksGT;
            this.linkAuditoria = true;
        } else if (this.usuario.perfis.toUpperCase().indexOf('ADMIN') >= 0) {
            this.linksExibir = this.linksAdmin;
        }

        if (this.usuario.perfis.toUpperCase().indexOf('SECRETARIA') >= 0 || this.usuario.perfis.toUpperCase().indexOf('EXECUTIVO') >= 0) {
            // Secretaria e CE
            this.linksExibir = this.linksPadrao;
            this.linkAuditoria = true;
        }
        this.norma();
    }

    public logoff() {
        this.authService.logoff();
        this.router.navigate(['/pages/login']);
    }

    public navegar(linkUrl: string) {
        this.router.navigate([linkUrl], { queryParams: { 'c': this.i++ } });
    }

    public norma() {
        this.sgService.getListaArquivoNorma(this.usuario.listaSiglaSistemaGestao ? this.usuario.listaSiglaSistemaGestao : '')
            .then(item => {
                this.listaSistemaGestao = item;
            });
    }
}



// WEBPACK FOOTER //
// /app/src/app/components/app-header/app-header.component.ts